export const disableFilters = (currentFilters, targetFilters) =>
  currentFilters.filter(f => !targetFilters.includes(f));

export const enableFilters = (currentFilters, targetFilters) => [
  ...currentFilters,
  ...targetFilters
];

export default { disableFilters, enableFilters };
